export {};
//# sourceMappingURL=class-transformer-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/class-transformer-options.interface.js
// module id = 789
// module chunks = 3